import { Typography, Box } from "@mui/material";
import VisualScroll from "./VisualScroll";
import LandingImageCarousel from "../landing/LandingImageCarousel";

interface TopSectionProps {
    title: string;
    desc: string;
    contentTranslateY?: number;
    descBottom?: number;
    maxTitleFont?: string;
    carousel?: boolean;
}

export default function TopSection({title, desc, descBottom = 0, maxTitleFont= '124px', carousel = false}: TopSectionProps) {
    return (
        <Box
            sx={{
                position: "sticky",
                top: 0,
                width: "100%",
                height: "100vh",
                backgroundColor: "#111111",
                zIndex: 2,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "50px 0 30px",
                gap: "40px",
                flex: "0 0 auto",
            }}
        >
            {carousel && (
                <LandingImageCarousel />
            )}
            
            <Box
                sx={{
                    width: "100%",
                    maxWidth: "1208px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    overflow: "visible",
                    position: "relative",
                    padding: 0,
                    gap: 0,
                    mixBlendMode: "difference", 
                }}
            >        
                <Box
                    sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    maxWidth: "550px",
                    alignItems: "center",
                    padding: "3px 5px",
                    width: "min-content",
                    overflow: "visible",
                    position: "relative",
                    }}
                >
                    <Typography
                        sx={{
                            fontWeight: 500,
                            letterSpacing: "0.04em",
                            fontSize: 16,
                            textAlign: "center",
                            whiteSpace: 'nowrap',
                            color: "rgb(128, 128, 128)",
                        }}
                    >
                    SINCE — Y:2022
                    </Typography>
                </Box>

                <Box
                    sx={{
                    width: "100%",
                    padding: "0 0 50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "10px",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: `clamp(48px, 10vw, ${maxTitleFont})`,
                            lineHeight: '120%',
                            maxWidth: '1205px',
                            color: "white",
                            wordBreak: "break-word", 
                            whiteSpace: "pre-line", 
                            textAlign: "center",
                            px: 2,
                        }}
                    >
                    {title}
                    </Typography>
                </Box>

                <Box
                    sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                    maxWidth: "600px",
                    width: "100%",
                    alignItems: "center",
                    overflow: "visible",
                    padding: 0,
                    position: "relative",
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 'clamp(16px, 2.2vw, 18px)',
                            lineHeight: 1.8,
                            position: "relative",
                            bottom: descBottom,
                            color: "rgb(128, 128, 128)",
                            textAlign: "center",
                            wordBreak: "break-word", 
                            whiteSpace: "pre-line", 
                            px: 2,
                        }}
                    >
                    {desc}
                    </Typography>
                </Box>
            </Box>

            <Box
                sx={{
                    position: "absolute",
                    bottom: 48,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                }}
                >

                <VisualScroll />

                <Typography
                    sx={{
                    fontSize: 14,
                    color: "rgb(128, 128, 128)",
                    letterSpacing: "0.1em",
                    mt: 8.6,
                    }}
                >
                    SCROLL
                </Typography>
            </Box>
        </Box>
    );
}
